import { Controller } from 'stimulus'
import { materializeLazyCell } from '@helpers'

// A value-only trait cell on the account samples grid
// (account_samples/_cell_trait). On first edit, swap in the real inline
// editor cloned from the column's <template> and open it. Focus is left to
// inline-editable-form's connect() (its setOriginalValue rAF focuses the
// field once the .form is visible), which also fires the field's focus event
// so the outside-click-to-close listener gets registered.
export default class extends Controller {
  edit() {
    const td = this.element
    if (!materializeLazyCell(td)) return

    const container = $(td)
    container.find('.value').hide()
    container.find('.form').show()
    container.data('keyboardNav', false)
  }
}
